module.exports = __webpack_public_path__ + "static/img/lwrs.cea8c377.png";